import React from 'react'
import { PostHogProvider } from 'posthog-js/react'

const PRODUCTION_HOST = 'kinstak.com'

/**
 * Wraps the PostHogProvider component and only initializes PostHog in production.
 *
 * Note: This component will not disable manual PostHog tracking via `posthog.capture()` or `posthog.captureEvent()`.
 *
 * @param props - The props for the PostHogProvider component, see [PostHogProvider](https://posthog.com/docs/libraries/react#posthog-provider) docs for more details.
 * @returns The wrapped PostHogProvider component or the children if not in production.
 */
export const PostHogProviderWrapper = ({ children, client, ...props }) => {
  const isProduction = window.location.host === PRODUCTION_HOST

  if (!isProduction || !client) return <>{children}</>
  return (
    <PostHogProvider client={client} {...props}>
      {children}
    </PostHogProvider>
  )
}
